import './Weinkeller.css';
import weinkellerImg from '../../assets/images/Weinkeller.jpg';

function Weinkeller() {
  return (
    <section className="weinkeller">
      <div className="weinkeller__inner">
        <div className="weinkeller__header">
          <span className="weinkeller__label">Weinbar &amp; Keller</span>
          <h2 className="weinkeller__title">Über 2400 ausgewählte Weine</h2>
          <div className="weinkeller__divider" />
          <p className="weinkeller__text">
            aus der ganzen Welt. Bei den Weißweinen liegt unser Schwerpunkt bei Deutschen,
            Italienischen und Österreichischen Tropfen. Bei den Rotweinen dominiert Italien,
            Frankreich und Österreich, aber auch Spanien, Portugal und Übersee sind reichlich
            vertreten. Besonders stolz sind wir auf unsere große Anzahl gereifter Wein-Raritäten.
          </p>
        </div>
        <div className="weinkeller__image-wrap">
          <img src={weinkellerImg} alt="Weinkeller – Über 2400 ausgewählte Weine" className="weinkeller__image" />
        </div>
      </div>
    </section>
  );
}

export default Weinkeller;
